import React, { forwardRef, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@quantum-ecosystem/ui-toolkit';

const FormCheckbox = forwardRef(({ indeterminate, error, description, hint, wrapperClassName = '', style, ...props }, forwardedRef) => {
	const inputRef = useRef(null);
	const setRef = useCallback((node) => {
		inputRef.current = node;
		if (typeof forwardedRef === 'function') forwardedRef(node);
		else if (forwardedRef) forwardedRef.current = node;
	}, [forwardedRef]);
	useEffect(() => {
		if (inputRef.current) inputRef.current.indeterminate = Boolean(indeterminate);
	}, [indeterminate]);
	return <div className={`q-form-group q-form-checkbox-group ${wrapperClassName}`.trim()} style={style}>
		<Checkbox ref={setRef} {...props} />
		{error ? <div className="q-form-error">{error}</div> : hint || description ? <div className="q-form-hint">{hint ?? description}</div> : null}
	</div>;
});

FormCheckbox.displayName = 'FormCheckbox';
FormCheckbox.propTypes = {
	indeterminate: PropTypes.bool,
	error: PropTypes.node,
	description: PropTypes.node,
	hint: PropTypes.node,
	wrapperClassName: PropTypes.string,
	style: PropTypes.object,
};

export default FormCheckbox;
